import { render, staticRenderFns } from "./RouterPassThroughMainMenu.vue?vue&type=template&id=67b10f8d&scoped=true&"
import script from "./RouterPassThroughMainMenu.vue?vue&type=script&lang=js&"
export * from "./RouterPassThroughMainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b10f8d",
  null
  
)

export default component.exports